import React, {useEffect, useState} from 'react';
import {AppTextEditor, EventReminderButton, EventReminderPanel, FormPageRoot, ThemedButton, ThemedInput} from "../../../index";
import {useTheme} from "../../../../common/ProjectThemeProvider";
import {
    checkNullArr,
    checkNullJson,
    checkNullStr,
    createTimeout,
    formatDateToIoString,
    getArrIndexValue,
    getCurrUrlParamValue,
    getJsonValue,
    getJsonValueFromNestedKeys,
    isBoolTrue,
    isDateExpired,
    isJsonValueTrue,
    parseInteger,
    trim
} from "../../../../common/fusion-ui/utils/ReactUtils";
import {focusFormIdElement, isCurrUserRoleAdmin, printError, printLog, sendRequest} from "../../../utils/AppUtils";
import {useToast} from "../../../../common/fusion-ui/provider/ToastProvider";
import {useLocation, useNavigate} from "react-router-dom";
import {
    EVENT_INPUT_MAX_LEN,
    EventFormParticipantTypes as PARTICIPANT_TYPES,
    GenRouteUrls,
    INPUT_FILE_MAX_SIZE,
    ModuleFieldsData,
    ModuleRouteUrls,
    Modules,
    ReqUrls,
    ShowViewType,
} from "../../../config/AppConfig";
import {Avatar, Checkbox, Flexbox, GridBox, Label, MsgBox, PdfViewer, RadioToggle, SearchableCheckboxList} from "../../../../common/fusion-ui";
import {Constants, CssVariant, Messages} from "../../../../common/fusion-ui/config/FusionConfig";
import {Tooltip} from "@mui/material";
import {useInternetStatus} from "../../../../common/fusion-ui/hook";
import {UnderMaintenance, UnderMaintenanceMsg} from "../../../../common/CommonConfig";

const Survey_AddEdit_Page = React.memo(({
                                            updateOnly,
                                            open,
                                            onHide,
                                            recordId,
                                            showAs = ShowViewType.PAGE,
                                            onSuccess,

                                        }) => {
    const TAG = "Survey_AddEdit_Page";

    const moduleName = Modules.Survey;
    const mf = ModuleFieldsData[moduleName];
    const NAME_KEY = 'name';

    const theme = useTheme();
    const location = useLocation();
    const navigate = useNavigate();
    const {showToast, changeToastVariant} = useToast();
    const {isOnline, internetCheckingMsg} = useInternetStatus();
    // const {isScreenXs, isScreenSm, isScreenMd, isScreenResizing} = useScreenSize();

    const FOCUS_DELAY = 2000;

    const REMINDER_TYPES = {
        //Do not send reminders
        // On survey creation
        // 15 days before
        // 7 days before
        // 3 days before
        // One day before
        // 3 hours before
        // 1 hour before
        // 15 minutes before
        doNot: {
            title: "Do not send reminders",
            column_Email: ModuleFieldsData[moduleName].reminder_doNotEmail.column,
            column_Sms: ModuleFieldsData[moduleName].reminder_doNotSms.column,
        },
        event: {
            title: "On survey creation",
            column_Email: ModuleFieldsData[moduleName].reminder_eventEmail.column,
            column_Sms: ModuleFieldsData[moduleName].reminder_eventSms.column,
        },
        _15DaysBefore: {
            title: "15 days before",
            column_Email: ModuleFieldsData[moduleName].reminder_day15Email.column,
            column_Sms: ModuleFieldsData[moduleName].reminder_day15Sms.column,
        },
        _7DaysBefore: {
            title: "7 days before",
            column_Email: ModuleFieldsData[moduleName].reminder_day7Email.column,
            column_Sms: ModuleFieldsData[moduleName].reminder_day7Sms.column,
        },
        _3DaysBefore: {
            title: "3 days before",
            column_Email: ModuleFieldsData[moduleName].reminder_day3Email.column,
            column_Sms: ModuleFieldsData[moduleName].reminder_day3Sms.column,
        },
        _1DaysBefore: {
            title: "One day before",
            column_Email: ModuleFieldsData[moduleName].reminder_day1Email.column,
            column_Sms: ModuleFieldsData[moduleName].reminder_day1Sms.column,
        },
        _3HrBefore: {
            title: "3 hours before",
            column_Email: ModuleFieldsData[moduleName].reminder_hrs3Email.column,
            column_Sms: ModuleFieldsData[moduleName].reminder_hrs3Sms.column,
        },
        _1HrBefore: {
            title: "1 hour before",
            column_Email: ModuleFieldsData[moduleName].reminder_hrs1Email.column,
            column_Sms: ModuleFieldsData[moduleName].reminder_hrs1Sms.column,
        },
        _15MinBefore: {
            title: "15 minutes before",
            column_Email: ModuleFieldsData[moduleName].reminder_min15Email.column,
            column_Sms: ModuleFieldsData[moduleName].reminder_min15Sms.column,
        },
    };
    const SURVEY_TYPES = {
        internal: 'Internal Survey',
        external: 'External Survey',
    };

    const Fields = {
        updateRecordId: 'updateRecordId',

        canShowAddForm: 'canShowAddForm',
        isUpdateFormDataFetched: 'isUpdateFormDataFetched',

        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',

        participantsLoading: 'participantsLoading',
        resetParticipantsList: 'resetParticipantsList',
        participantsLoaded: 'participantsLoaded',
        participantsLoadingMsg: 'participantsLoadingMsg',

        submitBtn_AsLoading: 'submitBtn_AsLoading',
        submitBtn_disabled: 'submitBtn_disabled',

        currParticipantGroupId: 'currParticipantGroupId',
        isPdfFileLoading: 'isPdfFileLoading',

        openEventReminderPopup: 'openEventReminderPopup',
        recordId_eventReminder: 'recordId_eventReminder',

        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',
    };
    const [fieldsData, setFieldsData] = useState({});
    // const [formData, setFormData] = useState(Survey_AddEdit_Page_FormData);
    const [formData, setFormData] = useState({});
    const [formFieldsMsgs, setFormFieldsMsgs] = useState({});

    useEffect(() => {
        if (!checkNullStr(getFormField(mf.timezone)) && !isUpdateMode()) {
            updateFormField(mf.participantDisplayType, PARTICIPANT_TYPES.membersOnly);
            updateFormField(mf.type, SURVEY_TYPES.internal);
            updateFormField(mf.timezone, true);
        }

        // log('useEffect.showAs:', showAs, 'recordId:', recordId);
        if (showAs == ShowViewType.PAGE) {
            if (isUpdateMode()) {
                const id = getCurrUrlParamValue('id');
                fetchEditModeData(id);
            }
        } else {
            if (checkNullStr(recordId) && isUpdateMode()) {
                fetchEditModeData(recordId, false);
            }
        }
        if (!isUpdateMode()) {
            fetchParticipantList([], true);
        }
    }, [recordId, showAs, updateOnly]);

    return (<>
        <FormPageRoot
            tag={TAG}
            moduleName={moduleName}
            addPageTitle={getTabTitle()}
            editPageTitle={getTabTitle()}
            updateOnly={isUpdateMode()}
            isDataLoading={getField(Fields.isDataLoading)}
            isDataFound={getField(Fields.isDataFound)}
            dataLoadingMsg={getField(Fields.dataLoadingMsg)}
            open={open}
            onHide={() => {
                if (onHide) onHide();
                clearPanelData();
            }}
            showAs={showAs}>
            <div>
                {/*top-section*/}
                <div>
                    {/*startDate*/}
                    <ThemedInput
                        mainWrapperClassName={''}
                        wrapperClassName={''}
                        className={''}
                        label={mf.startDate.titleAlt}
                        id={mf.startDate.column}
                        type={'datetime-local'}
                        value={getFormField(mf.startDate)}
                        msg={getFormFieldMsg(mf.startDate)}
                        required={true}
                        onChange={(e) => {
                            const value = e.target.value;//2024-04-19T15:34
                            updateFormField(mf.startDate, value);

                            //get am/pm as well
                            try {
                                // Extract the time portion from the selected date-time string
                                const time = (value + '').split('T')[1].substring(0, 5);
                                const hour = parseInt(time.split(':')[0]);

                                // Determine whether it's AM or PM based on the hour
                                const period = hour >= 12 ? 'PM' : 'AM';
                                // log('date-startDateAmPm.input.onChange.period:', period, 'value:', value);
                                updateFormField(mf.startDateAmPm, period);
                            } catch (error) {
                                logErr('date-startDateAmPm.input.onChange.period.error:', error);
                            }
                            if (checkNullStr(value)) {
                                updateFormFieldMsg(mf.startDate, '');
                            }
                        }}
                    />
                    {/*endDate*/}
                    <ThemedInput
                        mainWrapperClassName={''}
                        wrapperClassName={''}
                        className={''}
                        label={mf.endDate.titleAlt}
                        id={mf.endDate.column}
                        type={'datetime-local'}
                        value={getFormField(mf.endDate)}
                        msg={getFormFieldMsg(mf.endDate)}
                        required={true}
                        onChange={(e) => {
                            const value = e.target.value;//2024-04-19T15:34
                            updateFormField(mf.endDate, value);

                            //get am/pm as well
                            try {
                                // Extract the time portion from the selected date-time string
                                const time = (value + '').split('T')[1].substring(0, 5);
                                const hour = parseInt(time.split(':')[0]);

                                // Determine whether it's AM or PM based on the hour
                                const period = hour >= 12 ? 'PM' : 'AM';
                                // log('date-endDateAmPm.input.onChange.period:', period, 'value:', value);
                                updateFormField(mf.endDateAmPm, period);
                            } catch (error) {
                                logErr('date-endDateAmPm.input.onChange.period.error:', error);
                            }
                            if (checkNullStr(value)) {
                                updateFormFieldMsg(mf.endDate, '');
                            }
                        }}
                    />
                    {/*timezone*/}
                    <div className={'mt-2x'}>
                        {/*timezone*/}
                        <Checkbox
                            wrapperClassName={''}
                            className={''}
                            defaultChecked={isFormFieldTrue(mf.timezone)}
                            checked={isFormFieldTrue(mf.timezone)}
                            onChange={(e, value) => {
                                // log('timezone.cb.onChange.value:', value);
                                updateFormField(mf.timezone, value);
                            }}>
                            {mf.timezone.title}
                        </Checkbox>

                    </div>

                    {/*title & outline*/}
                    <div className={'mt-2'}>
                        {/*title*/}
                        <ThemedInput
                            wrapperClassName={''}
                            className={''}
                            label={mf.title.titleAlt}
                            placeholder={mf.title.titleAlt}
                            id={mf.title.column}
                            type={'text'}
                            value={getFormField(mf.title)}
                            showLimitLabel={true}
                            maxLength={EVENT_INPUT_MAX_LEN}
                            required={true}
                            onChange={(e) => {
                                updateFormField(mf.title, e.target.value);
                            }}
                        />

                        {/*desc-editor*/}
                        <div className={'mt-x'}>
                            {createLabelField(mf.desc.titleAlt, true)}
                            <AppTextEditor
                                id={mf.desc.column}
                                value={getFormField(mf.desc)}
                                onChange={(content) => {
                                    // log('desc.AppTextEditor.onChange.content:', content);
                                    updateFormField(mf.desc, content);
                                }}/>
                        </div>

                        {/*introduction-editor*/}
                        <div className={'mt-3'}>
                            {createLabelField(mf.introduction.titleAlt, true)}
                            <AppTextEditor
                                id={mf.introduction.column}
                                value={getFormField(mf.introduction)}
                                onChange={(content) => {
                                    // log('introduction.AppTextEditor.onChange.content:', content);
                                    updateFormField(mf.introduction, content);
                                }}/>
                        </div>
                    </div>
                </div>

                {/*survey-type*/}
                <div className={'mt-3'}>
                    {createLabelField(mf.type.title, true)}
                    <RadioToggle
                        className={`bg-infox px-3x`}
                        radioClassName={'w-auto'}
                        labelClassName={'fw-semi-bold text-input-label'}
                        labelColor={theme.text40}
                        cbPy={0}
                        required={true}
                        checked={getFormField(mf.type) == SURVEY_TYPES.internal}
                        config={{
                            active: SURVEY_TYPES.internal,
                            inactive: SURVEY_TYPES.external,
                        }}
                        onChange={(e, value) => {
                            // log('type.RadioToggle.onChange.value:', value);
                            updateFormField(mf.type, value);
                        }}
                    />

                    {/*SurveyType == external*/}
                    {getFormField(mf.type) == SURVEY_TYPES.external &&
                        <div className={'px-1'}>
                            <ThemedInput
                                wrapperClassName={'mt-1'}
                                className={''}
                                label={mf.link.titleAlt}
                                placeholder={mf.link.titleAlt}
                                id={mf.link.column}
                                type={'text'}
                                value={getFormField(mf.link)}
                                showLimitLabel={true}
                                maxLength={EVENT_INPUT_MAX_LEN}
                                required={true}
                                onChange={(e) => {
                                    updateFormField(mf.link, e.target.value);
                                }}
                            />
                        </div>}
                </div>

                {/* participants cb-list   */}
                <div className={'mt-3'}>
                    {createLabelField(mf.participants.title, true)}

                    {/*participantDisplayType*/}
                    <RadioToggle
                        className={`bg-infox px-3x`}
                        radioClassName={'w-auto'}
                        labelClassName={'fw-semi-bold text-input-label'}
                        labelColor={theme.text40}
                        cbPy={0}
                        required={true}
                        checked={getFormField(mf.participantDisplayType) == PARTICIPANT_TYPES.membersOnly}
                        config={{
                            // label: "Participant Type",
                            active: PARTICIPANT_TYPES.membersOnly,
                            inactive: PARTICIPANT_TYPES.groupsOnly,
                        }}
                        onChange={(e, value) => {
                            // log('participantDisplayType.RadioToggle.onChange.value:', value);
                            updateFormField(mf.participantDisplayType, value);
                        }}
                    />
                    {/*participants & groups*/}
                    <div className={'px-2'}>
                        {/*groups grid*/}
                        {(getFormField(mf.participantDisplayType) == PARTICIPANT_TYPES.groupsOnly) && <div>
                            {(checkNullArr(getParticipantGroupsList()))
                                ? <GridBox className={'px-3'} sm={12} md={4} gap={0}>
                                    {getParticipantGroupsList().map((cbItem, index) => {
                                        return (checkNullJson(cbItem)) && <Checkbox
                                            key={cbItem[NAME_KEY] + index}
                                            wrapperClassName={''}
                                            className={''}
                                            labelClassName={'fw-semi-bold'}
                                            // defaultChecked={getParticipantGroupsList().some(item => item[NAME_KEY] == cbItem[NAME_KEY] && isBoolTrue(cbItem.selected))}
                                            // checked={getParticipantGroupsList().some(item => item[NAME_KEY] == cbItem[NAME_KEY] && isBoolTrue(cbItem.selected))}
                                            defaultChecked={getField(Fields.currParticipantGroupId) == cbItem.id}
                                            checked={getField(Fields.currParticipantGroupId) == cbItem.id}
                                            onChange={(e, value) => {
                                                updateField(Fields.currParticipantGroupId, value ? cbItem.id : null);
                                                // log('participantGroupNames.map.cb.onChange.value:', value, 'id:', cbItem.id);

                                                let names = getParticipantGroupsList();
                                                names = names.map((nameItem) => {
                                                    return {
                                                        ...nameItem,
                                                        selected: nameItem[NAME_KEY] == cbItem[NAME_KEY] ? value : isBoolTrue(nameItem.selected),
                                                    }
                                                });
                                                updateFormField(mf.participantGroupNames, names);
                                                // log('participantGroupNames.map.cb.onChange.value:', value, '\nnames:', names);
                                                // log('curr-cbItem.name:', cbItem.name, 'curr-name-found', names.some(item => (isJsonValueTrue(item,'selected'))));
                                            }}
                                        >{cbItem.name}</Checkbox>
                                    })}
                                </GridBox>
                                : createLabelField('No groups found!', false, theme.text, '')}
                        </div>}

                        {/*participant-list*/}
                        <div className={'mt-2'}>
                            <SearchableCheckboxList
                                roundedVariant={4}
                                listHeight={'50vh'}
                                searchPlaceholder={'Search members...'}
                                borderColor={theme.text30}
                                showSelect={false}
                                pad={2}
                                checkListColumnCount={3}
                                showDisplaySelectedOnly={true}
                                isCheckItemJson={true}
                                checkItemJsonIdKey={'id'}
                                checkItemJsonTextKey={'name'}
                                checkDataList={getParticipantList()}
                                onValueChange={(e, value, selectedList) => {
                                    // log('participantNames-searchList.onValueChange.selectedList:', selectedList, 'len:', selectedList.length);
                                    updateFormField(mf.participantNamesSelectedOnly, selectedList);
                                }}
                            />
                        </div>
                    </div>
                </div>

                {/*related-docs*/}
                <div className={'mt-3'}>
                    {/*document-img*/}
                    <GridBox className={'px-2'} md={[4, 8]} sm={[12, 12]}>
                        <div className={' px-2'}>
                            <Avatar
                                wrapperClassName={'w-100'}
                                className={''}
                                labelClassName={'w-100x pb-2 text-startxx'}
                                justifyAt={'center'}
                                alignAt={'start'}
                                wrap={'wrap'}
                                direction={'column'}
                                label={mf.doc.title}
                                labelColor={theme.text40}
                                accept={'.pdf, .jpg, .jpeg, .png'}
                                editTooltip={`Edit (.pdf, .jpg, .jpeg, .png)`}
                                showEdit={true}
                                showDelete={true}
                                circular={false}
                                showFullPreviewDialog={true}
                                defAvatarImg={Constants.docVector}
                                editSize={'21px'}
                                width={'100px'}
                                height={'140px'}
                                maxSize={INPUT_FILE_MAX_SIZE}
                                onChange={(e, file, path, name, ext) => {
                                    //log('Avatar.doc.onChange.name:', name);
                                    updateFormField(mf.doc, file);
                                    updateFormField(mf.docFileExt, ext);
                                }}
                                onInvalidFormat={(e, name) => {
                                    toast(`Invalid file format. File must be pdf, jpg, jpeg or png`, CssVariant.danger);
                                }}
                                onSizeExceeded={() => {
                                    toast(`Max size exceeded: ${INPUT_FILE_MAX_SIZE}`, CssVariant.danger);
                                }}
                                onFileLoading={(loading) => {
                                    updateField(Fields.isPdfFileLoading, isBoolTrue(loading));
                                }}>{getFormField(mf.doc)}</Avatar>
                        </div>

                        {/*pdf-viewer*/}
                        {/*pdf-viewer*/}
                        {(checkNullStr(getFormField(mf.doc)) &&
                                (getFormField(mf.docFileExt) + '').toLowerCase().trim().endsWith('.pdf')
                                && !isFieldTrue(Fields.isPdfFileLoading)) &&
                            <div className={'ps-3x'}>
                                <PdfViewer
                                    label={`${mf.doc.titleAlt} Preview`}
                                    pdfTitle={mf.doc.titleAlt}
                                    src={getFormField(mf.doc)}
                                    labelColor={theme.text}
                                    height={'240px'}
                                />
                            </div>}
                    </GridBox>
                    {/*docDesc*/}
                    <ThemedInput
                        wrapperClassName={'w-100 mt-3 pb-3'}
                        className={''}
                        label={mf.docDesc.title}
                        placeholder={mf.docDesc.title}
                        id={mf.docDesc.column}
                        showLimitLabel={true}
                        maxLength={EVENT_INPUT_MAX_LEN}
                        type={'text'}
                        value={getFormField(mf.docDesc)}
                        showMsg={false}
                        onChange={(e) => {
                            updateFormField(mf.docDesc, e.target.value);
                        }}
                    />
                </div>

                <div className={'mt-3x'}>
                    {createLabelField(mf.reminders.title)}
                    {/*reminder & cbs in table*/}
                    <div className={'px-2 mt-n1'}>
                        <table className={'w-100 m-0 p-0 '} style={{color: theme.text}}>
                            <thead>
                            <tr>
                                <th>{mf.reminders.titleAlt}</th>
                                <th className={'text-nowrap text-center-forcex'}>
                                    <input className={''}
                                           type="checkbox"
                                        // defaultChecked={isFormFieldTrue(item.column_Email, true)}
                                        // checked={isFormFieldTrue(item.column_Email, true)}
                                           onChange={(e) => {
                                               const checked = e.target.checked;
                                               const remColumns = Object.values(REMINDER_TYPES)
                                                   .filter(item => item.column_Email != REMINDER_TYPES.doNot.column_Email)
                                                   .map(item => item.column_Email)
                                                   .map(item => ({[item]: checked}))
                                                   .reduce((acc, obj) => ({...acc, ...obj}), {});
                                               log('Email-header: remColumns:', remColumns, 'checked:', checked);
                                               setFormData(prevState => ({...prevState, ...remColumns}));
                                           }}
                                    />
                                    <span>&nbsp;Email</span>
                                </th>
                                <th className={'text-nowrap text-center-forcex'}>
                                    <input className={''}
                                           type="checkbox"
                                        // defaultChecked={isFormFieldTrue(item.column_Sms, true)}
                                        // checked={isFormFieldTrue(item.column_Sms, true)}
                                           onChange={(e) => {
                                               const checked = e.target.checked;
                                               const remColumns = Object.values(REMINDER_TYPES)
                                                   .filter(item => item.column_Sms != REMINDER_TYPES.doNot.column_Sms)
                                                   .map(item => item.column_Sms)
                                                   .map(item => ({[item]: checked}))
                                                   .reduce((acc, obj) => ({...acc, ...obj}), {});
                                               log('Sms-header: remColumns:', remColumns, 'checked:', checked);
                                               setFormData(prevState => ({...prevState, ...remColumns}));
                                           }}
                                    />
                                    <span>&nbsp;SMS</span>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {Object.values(REMINDER_TYPES).map((item, index) => {
                                return (checkNullJson(item)) && <tr
                                    className={''}
                                    key={index + item.column_Email}>
                                    <td className={''}>{item.title}</td>
                                    {/*email-cb*/}
                                    <td className={'text-center-forcex'}>
                                        <input
                                            type="checkbox"
                                            defaultChecked={isFormFieldTrue(item.column_Email, true)}
                                            checked={isFormFieldTrue(item.column_Email, true)}
                                            onChange={(e) => {
                                                const checked = isBoolTrue(e.target.checked);
                                                // log('reminders.map.email-cb.onChange.checked:', checked, 'item:', item, 'formData', formData);
                                                updateFormField(item.column_Email, checked, true);
                                            }}
                                        />
                                    </td>
                                    {/*sms-cb*/}
                                    <td className={'text-center-forcex'}>
                                        <input
                                            type="checkbox"
                                            defaultChecked={isFormFieldTrue(item.column_Sms, true)}
                                            checked={isFormFieldTrue(item.column_Sms, true)}
                                            onChange={(e) => {
                                                const checked = isBoolTrue(e.target.checked);
                                                // log('reminders.map.sms-cb.onChange.checked:', checked, 'item:', item, 'formData', formData);
                                                updateFormField(item.column_Sms, checked, true);
                                            }}
                                        />
                                    </td>
                                </tr>
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>


                {/*footer*/}
                <div className={'mt-3'}>
                    {/*msg-box*/}
                    {checkNullStr(getField(Fields.panelMsg)) && <MsgBox color={getField(Fields.panelMsgColor, theme.text)}>
                        {getField(Fields.panelMsg)}
                    </MsgBox>}

                    {/* reminder send-btn */}
                    {(isUpdateMode() && isCurrUserRoleAdmin()) &&
                        <Flexbox className={'my-3 w-100'} justifyAt={'center'}>
                            <Tooltip title={isDateExpired(getFormField(mf.startDate)) ? `Can't send reminder for an expired event!` : ''}>
                                <div>
                                    {isCurrUserRoleAdmin() && <EventReminderButton
                                        ml={2}
                                        disabled={isDateExpired(getFormField(mf.startDate))}
                                        onClick={() => {
                                            if (checkNullArr(getFormField(mf.participantNamesSelectedOnly))) {
                                                updateField(Fields.openEventReminderPopup, true);
                                                updateField(Fields.recordId_eventReminder, getField(Fields.updateRecordId));
                                            } else {
                                                toast("Please select some participants first", CssVariant.warning);
                                            }
                                        }}
                                    />}
                                </div>
                            </Tooltip>
                        </Flexbox>}

                    {/*controls*/}
                    <Flexbox className={'mt-3'} justifyAt={'center'} alignAt={'center'}>
                        {/*cancel*/}
                        {(showAs == ShowViewType.DRAWER || showAs == ShowViewType.DIALOG) && <ThemedButton
                            className={'rounded-2 w-auto px-4 py-1'}
                            text={'Cancel'}
                            variant={theme.text10}
                            hoverBgColor={theme.text30}
                            color={theme.text}
                            onClick={() => {
                                if (onHide) onHide();
                                clearPanelData();
                            }}
                            mx={2}
                        />}

                        {/*submit*/}
                        <ThemedButton
                            className={'rounded-2 w-auto px-4 py-1'}
                            text={isFieldTrue(Fields.submitBtn_AsLoading)
                                ? isUpdateMode() ? 'Updating...' : 'Saving...'
                                : isUpdateMode() ? 'Update' : 'Save'}
                            variant={theme.primaryBlue}
                            hoverBgColor={theme.primaryBlueDark}
                            loadingWidth={'auto'}
                            asLoading={isFieldTrue(Fields.submitBtn_AsLoading)}
                            disabled={isFieldTrue(Fields.submitBtn_disabled)}
                            onClick={handleSubmit}
                        />
                    </Flexbox>
                </div>
            </div>
        </FormPageRoot>
        {(isUpdateMode() && isCurrUserRoleAdmin()) && createEventReminderPopup()}
    </>)

    function createEventReminderPopup() {
        return <EventReminderPanel
            moduleName={moduleName}
            recordId={getField(Fields.recordId_eventReminder)}
            recordUrl={`${GenRouteUrls.survey_internalPage}${getField(Fields.recordId_eventReminder)}`}
            open={isFieldTrue(Fields.openEventReminderPopup)}
            recordData={{
                title: getFormField(mf.title),
                description: getFormField(mf.desc),
                startDate: getFormField(mf.startDate),
                endDate: getFormField(mf.endDate),
                link: getFormField(mf.link),
                selectedParticipants: checkNullArr(getFormField(mf.participantNamesSelectedOnly))
                    ? getFormField(mf.participantNamesSelectedOnly).map(item => ({id: getJsonValue(item, 'id')}))
                    : [],
            }}
            onDoneAndHide={() => {
                updateField(Fields.openEventReminderPopup, false);
                updateField(Fields.recordId_eventReminder, null);
            }}
        />
    }

    //======================UI Functions start=====================
    function createLabelField(label, required, color = theme.text40, className) {
        return <Label className={`text-input-label m-0 p-0 px-2 pb-1 ${className}`}
                      color={color} textAt={'start'} required={required}>
            {label}
        </Label>
    }

    //======================UI Functions end=====================

    //======================Request Functions start=====================
    function handleSubmit() {
        const fun = 'handleSubmit:';
        log(fun, 'formData:', formData);
        if (UnderMaintenance) {
            toast(UnderMaintenanceMsg, CssVariant.warning);
            return false;
        }
        if (!isOnline) {
            toast(internetCheckingMsg, CssVariant.warning);
            return false;
        }

        try {
            let allFieldsChecked = checkRequiredFields();
            // allFieldsChecked = false;//for checking
            if (allFieldsChecked) {
                updateField(Fields.submitBtn_AsLoading, true);
                updateField(Fields.submitBtn_disabled, true);

                const REQUEST_OPTIONS = {
                    updateOnly: isUpdateMode(),
                    recordId: getField(Fields.updateRecordId),
                    formData: formData,
                };
                sendRequest({
                    reqUrl: ReqUrls.survey__addEditPage_submit_formData,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');

                        // updateField(Fields.submitBtn_disabled, false);//for testing only
                        if (success) {
                            toast(message, CssVariant.success);
                            if (showAs == ShowViewType.PAGE) {
                                redirectPage();
                            } else {
                                createTimeout(() => {
                                    clearPanelData();
                                }, 300);
                            }
                            if (onSuccess) onSuccess();
                        } else {
                            toast(message, CssVariant.danger);
                            updateField(Fields.submitBtn_disabled, false);
                        }
                        updateField(Fields.submitBtn_AsLoading, false);
                    }),
                    onError: ((error) => {
                        toast(Messages.saveError, CssVariant.danger);
                        updateField(Fields.submitBtn_AsLoading, false);
                        updateField(Fields.submitBtn_disabled, false);
                        logErr(fun, error);
                    }),
                });
            }
        } catch (error) {
            toast(Messages.saveError, CssVariant.danger);
            updateField(Fields.submitBtn_AsLoading, false);
            updateField(Fields.submitBtn_disabled, false);
            logErr(fun, error);
        }
    }

    async function fetchParticipantList(selectedIntIds = [], isAddMode, formData = {}) {
        const fun = 'fetchParticipantList:';
        try {
            if (!isFieldTrue(Fields.participantsLoaded)) {
                updateField(Fields.participantsLoaded, true);
                updateField(Fields.participantsLoading, true);
                if (isBoolTrue(isAddMode)) {
                    updateField(Fields.isDataLoading, true);
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.dataLoadingMsg, "");
                }

                const REQUEST_OPTIONS = {};
                sendRequest({
                    reqUrl: ReqUrls.eventForm__fetch_participantsList,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        let members = getJsonValueFromNestedKeys(fetchedData, ['data', 'members'], []);
                        let groups = getJsonValueFromNestedKeys(fetchedData, ['data', 'groups'], []);
                        // log(fun, 'fetchedData.members:', members, 'groups:', groups);

                        //select selectedIntIds by-default
                        // if (isUpdateMode()) log(fun, 'selectedIntIds:', selectedIntIds);
                        if (checkNullArr(members) && checkNullArr(selectedIntIds)) {
                            members = members.map((item) => {
                                return {
                                    ...item,
                                    selected: checkNullArr(selectedIntIds) && selectedIntIds.includes(parseInteger(getJsonValue(item, 'id'), -1))
                                };
                            });
                            updateFormField(mf.participantNamesSelectedOnly, members.filter(filterItem => isJsonValueTrue(filterItem, 'selected')));
                        }

                        updateField(Fields.participantsLoading, false);
                        updateField(Fields.participantsLoaded, true);

                        updateFormField(mf.participantNames, members);
                        updateFormField(mf.participantGroupNames, groups);
                        if (isBoolTrue(isAddMode)) {
                            updateField(Fields.isDataLoading, false);
                            updateField(Fields.isDataFound, true);
                        }
                    }),
                    onError: ((error) => {
                        logErr(fun, error);
                        if (isBoolTrue(isAddMode)) {
                            updateField(Fields.isDataLoading, false);
                            updateField(Fields.isDataFound, true);
                        }
                        updateField(Fields.participantsLoading, false);
                        updateField(Fields.participantsLoaded, true);
                        updateField(Fields.participantsLoadingMsg, "Couldn't load participants!");
                    }),
                });
            }
        } catch (error) {
            logErr(fun, error);
            if (isBoolTrue(isAddMode)) {
                updateField(Fields.isDataLoading, false);
                updateField(Fields.isDataFound, true);
            }

            updateField(Fields.participantsLoading, false);
            updateField(Fields.participantsLoaded, true);
            updateField(Fields.participantsLoadingMsg, "Couldn't load participants!");
        }
    }

    async function fetchEditModeData(recordId, checkBefore = true) {
        const fun = 'fetchEditModeData:';
        try {
            // log(fun, 'recordId:', recordId, 'isUpdateFormDataFetched:', isFieldTrue(Fields.isUpdateFormDataFetched));

            if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isUpdateFormDataFetched))) {
                updateField(Fields.isUpdateFormDataFetched, true);
                updateField(Fields.updateRecordId, recordId);
                if (checkNullStr(recordId)) {
                    updateField(Fields.isDataLoading, true);
                    updateField(Fields.dataLoadingMsg, "");

                    //send-request
                    const REQUEST_OPTIONS = {
                        recordId: recordId,
                    };
                    sendRequest({
                        reqUrl: ReqUrls.survey__addEditPage_fetch_editFormData,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: ((fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const fetchedFormData = getJsonValue(fetchedData, 'data', {});
                            const success = checkNullJson(fetchedFormData);

                            updateField(Fields.isDataFound, success);
                            if (success) {
                                // toast('Successfully fetched your data.', CssVariant.success);

                                //modify the date-formats of start & end dates otherwise date-inputs won't show the dates
                                const startDate = formatDateToIoString(getJsonValue(fetchedFormData, mf.startDate.column));
                                const endDate = formatDateToIoString(getJsonValue(fetchedFormData, mf.endDate.column));
                                fetchedFormData[mf.startDate.column] = startDate
                                fetchedFormData[mf.endDate.column] = endDate
                                // log(fun, 'fetchedData.startDate:', startDate, 'endDate:', endDate, 'fetchedFormData-new:', fetchedFormData);
                                setFormData(fetchedFormData);

                                //Update participantDisplayType, bcuz it doesn't come from database
                                updateFormField(mf.participantDisplayType, PARTICIPANT_TYPES.membersOnly);

                                //extract participants ids to be by-default selected
                                const prtscptIdsStr = getJsonValue(fetchedFormData, mf.participantNames.column) + '';
                                // log(fun, 'fetchedData.prtscptIdsStr:', prtscptIdsStr);
                                //   if (checkNullStr(prtscptIdsStr)) {
                                const selectedIds = checkNullStr(prtscptIdsStr) ? prtscptIdsStr.split(',').map(item => parseInteger(trim(item), -1)) : [];
                                // log(fun, 'fetchedData.prtscptIdsStr.selectedIds:', selectedIds);
                                fetchParticipantList(selectedIds, false, fetchedFormData);
                                //    }
                            } else {
                                updateField(Fields.dataLoadingMsg, "Invalid record id!");
                            }
                            updateField(Fields.isDataLoading, false);
                        }),
                        onError: ((error) => {
                            logErr(fun, error);
                            updateField(Fields.dataLoadingMsg, Messages.fetchError);
                            updateField(Fields.isDataFound, false);
                            updateField(Fields.isDataLoading, false);
                        }),
                    });
                } else {
                    updateField(Fields.dataLoadingMsg, 'Record-id not found!');
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.isDataLoading, false);
                }
            }
        } catch (error) {
            logErr(fun, error);
            updateField(Fields.dataLoadingMsg, Messages.fetchError);
            updateField(Fields.isDataFound, false);
            updateField(Fields.isDataLoading, false);
        }
    }

    function redirectPage() {
        createTimeout(() => {
            panelLog(`Redirecting you to the '${moduleName}' page now...`);
            createTimeout(() => {
                window.location.href = ModuleRouteUrls[moduleName];
            }, 2500);
        }, 500);
    }

    function clearPanelData() {
        setFormFieldsMsgs({});
        setFormData({});
        setFieldsData({});
    }

    //======================Request Functions end=====================

    //======================Util Functions start=====================
    function checkRequiredFields() {
        const fun = 'checkRequiredFields:';
        const requiredFields = [
            mf.startDate,
            mf.endDate,
            mf.title,
            mf.desc,
            mf.introduction,
            mf.participantNamesSelectedOnly,
        ];
        if (getFormField(mf.type) == SURVEY_TYPES.external) {
            requiredFields.push(mf.link);
        }

        let verified = false;
        let colField = {};
        for (const field of requiredFields) {
            if (field.column === mf.participantNamesSelectedOnly.column) {
                // const names = (getJsonValue(formData, field.column));
                // log(fun, "requiredFields.field.participantNames.names:", names);
                if (checkNullArr(getJsonValue(formData, field.column))) {
                    verified = true;
                } else {
                    colField = field;
                    verified = false;
                    break;
                }
            } else if (!checkNullStr(formData[field.column])) {
                colField = field;
                verified = false;
                break;
            }
        }
        if (!verified) {
            // log(fun, "!verified.colField:", colField, 'idToFocus:', colField.column);
            updateFormFieldMsg(colField, 'Required field');
            toast(`'${colField.title}' cannot be empty!`, CssVariant.danger);
            focusIdField(colField.column);
        }
        // log('getParticipantList',getParticipantList());
        return verified;
    }

    function focusIdField(id, onlyFocus = false) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
    }

    function getParticipantList(filtered = true) {
        if (checkNullArr(getFormField(mf.participantNames))) {
            if (getFormField(mf.participantDisplayType) == PARTICIPANT_TYPES.groupsOnly && filtered) {
                const currGroupId = getField(Fields.currParticipantGroupId);
                if (checkNullStr(currGroupId) && checkNullArr(getParticipantGroupsList())) {
                    return getJsonValue(getArrIndexValue(getParticipantGroupsList().filter(item => item.id == currGroupId), 0, {}), 'members', []);
                } else {
                    return [];
                }
            } else {
                return getFormField(mf.participantNames);
            }
        } else {
            return []
        }
    }

    function getParticipantGroupsList() {
        if (checkNullArr(getFormField(mf.participantGroupNames))) {
            return getFormField(mf.participantGroupNames);
        } else {
            return []
        }
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function updateFormField(clmField, value, direct = false) {
        setFormData(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormField(clmField, defValue, direct = false) {
        return getJsonValue(formData, direct ? clmField : clmField.column, defValue);
    }

    function isFormFieldTrue(clmField, direct = false) {
        return isBoolTrue(getFormField(clmField, null, direct), true, true);
    }

    function updateFormFieldMsg(clmField, value, direct = false) {
        setFormFieldsMsgs(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormFieldMsg(clmField, defValue, direct = false) {
        return getJsonValue(formFieldsMsgs, direct ? clmField : clmField.column, defValue);
    }

    function isUpdateMode() {
        return isBoolTrue(updateOnly);
    }

    function getTabTitle() {
        return isUpdateMode() ? `Edit survey` : `Create a new survey`;
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        log(...[text]);
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default Survey_AddEdit_Page;
